import { Progress, Stack, Text, VStack } from "@chakra-ui/react";
import { FormEventHandler, ReactNode } from "react";
import { colors } from "../../../styles";

export const underlineInputProps = {
    borderBottom: `1px solid ${colors.g4}`,
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    borderRadius: "0",
    _focus: {
        borderBottom: `1px solid ${colors.blue}`,
        boxShadow: "none",
        outline: "none",
    },
};

export function FieldMessage({
    message,
    tone = "error",
}: {
    message?: string;
    tone?: "error" | "success" | "muted";
}) {
    if (!message) return null;

    const color = tone === "success" ? "green.500" : tone === "muted" ? colors.g3 : "red.500";

    return (
        <Text color={color} textAlign="start" fontSize="sm" marginTop={1}>
            {message}
        </Text>
    );
}

interface IStepLayoutProps {
    progress?: number;
    titles: string[];
    descriptions?: string[];
    asForm?: boolean;
    onSubmit?: FormEventHandler;
    children: ReactNode;
}

export default function StepLayout({
    progress,
    titles,
    descriptions,
    asForm,
    onSubmit,
    children,
}: IStepLayoutProps) {
    return (
        <VStack
            justifyContent="center"
            alignItems="center"
            padding={10}
            minHeight="100vh"
        >
            <Stack
                as={asForm ? "form" : undefined}
                onSubmit={onSubmit}
                width={{
                    base: "100%",
                    sm: "90%",
                    md: "60%",
                    lg: "40%",
                    xl: "40%",
                }}
            >
                {progress !== undefined && (
                    <Progress value={progress} colorScheme="blue" height="5px" />
                )}
                <VStack
                    padding={1}
                    spacing={0}
                    alignItems="flex-start"
                    width="100%"
                    marginTop={progress !== undefined ? 10 : 0}
                >
                    {titles.map((title) => (
                        <Text key={title} fontSize={28} fontWeight={700} color={colors.g1}>
                            {title}
                        </Text>
                    ))}
                    {descriptions?.map((description) => (
                        <Text
                            key={description}
                            fontSize={12}
                            fontWeight={500}
                            color={colors.g3}
                            marginTop={2}
                        >
                            {description}
                        </Text>
                    ))}
                </VStack>
                <VStack
                    marginTop={5}
                    padding={5}
                    alignItems="stretch"
                    width="100%"
                >
                    {children}
                </VStack>
            </Stack>
        </VStack>
    );
}
